<script lang="ts">
    interface Props {
        variationId: string;
        bestVariationBenefit?: string;
        rule?: string;
    }

    /**
 *
 *
 *
 *
 */
    const { variationId, bestVariationBenefit, rule }: Props = $props();
</script>

{#if bestVariationBenefit}
    <div class="reptile-sale-tags__benefit-tag">
        <ft9-benefit-tag-v1
            data-secondary-action
            id={`${variationId}-benefit-tag`}
            current-context-dreson={rule}
            team="reptile"
            feature="tilelist"
            data={bestVariationBenefit}
        ></ft9-benefit-tag-v1>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-sale-tags {
        &__benefit-tag {
            margin-top: -1.5px;
        }
    }
</style>
